var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isGetData)?_c('div',{staticClass:"index"},[_c('nav-left'),_c('div',{staticClass:"container"},[_c('top-header'),_c('router-view',{staticClass:"content-box"})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }